// Static site data (caravan park content)
export const SITE = {
  name: "Shady Acres Caravan Park",
  tagline: "Ballarat's quiet escape under the gums.",
  location: "Warrenheip, Ballarat, Victoria, Australia",
  address: "M8 / 9435 National Highway, Warrenheip VIC 3352",
  phone: "(03) 5334 7233",
  phone_intl: "+61353347233",
  email: "stay@shadyacrescaravanpark.com.au",
  mapEmbed:
    "https://maps.google.com/maps?q=Shady+Acres+Caravan+Park+Warrenheip+VIC+3352&hl=en&output=embed",
};

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/accommodation", label: "Stay" },
  { to: "/amenities", label: "Park" },
  { to: "/gallery", label: "Gallery" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export const HERO_IMAGE =
  "https://customer-assets.emergentagent.com/job_shady-booking-portal/artifacts/ljfu64cm_Home-Hero2.JPG";

export const ACCOMMODATIONS = [
  {
    id: "deposit_ensuite_cabin",
    slug: "ensuite-cabin",
    name: "Ensuite Cabin",
    rms_category_id: "",
    blurb:
      "Self-contained ensuite cabin sleeping up to six — linen, kitchenette, reverse-cycle A/C and a private deck.",
    price_from: 130,
    deposit: 150,
    sleeps: "Up to 6 guests",
    features: ["Queen + bunks/singles", "En-suite bathroom", "Reverse-cycle A/C", "Smart TV", "Private deck"],
    image:
      "https://customer-assets.emergentagent.com/job_shady-booking-portal/artifacts/o4e62xoc_5.png",
  },
  {
    id: "deposit_standard_cabin",
    slug: "standard-cabins",
    name: "Standard Cabin",
    rms_category_id: "",
    blurb:
      "A cosy, classic cabin for two — queen bed, kitchenette and everything you need for a relaxed Ballarat stay.",
    price_from: 90,
    deposit: 100,
    sleeps: "2 adults",
    features: ["Queen bed", "Heating", "Kitchenette", "Short walk to amenities"],
    image:
      "https://customer-assets.emergentagent.com/job_shady-booking-portal/artifacts/1eepqcyb_9.png",
  },
  {
    id: "deposit_powered_site",
    slug: "powered-sites",
    name: "Powered Site",
    rms_category_id: "",
    blurb:
      "Drive-through and back-in sites with 15A power and water. Concrete pads on selected sites.",
    price_from: 40,
    deposit: 75,
    sleeps: "2–6 guests",
    features: ["15A power", "Drive-through option", "Water tap", "Many gum-shaded sites"],
    image:
      "https://customer-assets.emergentagent.com/job_shady-booking-portal/artifacts/ipueo8re_Caravan.V1.png",
  },
  {
    id: "deposit_ensuite_powered_site",
    slug: "ensuite-powered-sites",
    name: "Ensuite Powered Site",
    rms_category_id: "",
    blurb:
      "Powered site with your own private en-suite bathroom — the best of caravan freedom and cabin comfort.",
    price_from: 45,
    deposit: 75,
    sleeps: "2–6 guests",
    features: ["15A power", "Private en-suite", "Water tap", "Drive-through option"],
    image:
      "https://customer-assets.emergentagent.com/job_shady-booking-portal/artifacts/xuitbnq0_Jaycar.png",
  },
  {
    id: "deposit_camping",
    slug: "camping",
    name: "Tent & Camping",
    rms_category_id: "",
    blurb:
      "Soft-grass unpowered sites under the gums, with easy access to amenities. Guests are welcome to bring their own fire pit or fire pan (BYOP).",
    note: "BYO fire pit / pan use must be checked and agreed with management on arrival, and is subject to Total Fire Ban days.",
    price_from: 35,
    deposit: 50,
    sleeps: "2–6 guests",
    features: ["Soft grass", "BYO fire pit (BYOP)", "Walk to amenities", "Kid-safe loop"],
    image:
      "https://customer-assets.emergentagent.com/job_shady-booking-portal/artifacts/1trbbt6e_image.png",
  },
];

// Things to do nearby — drives "stay at our caravan park, explore Ballarat" SEO angle.
export const NEARBY = [
  {
    title: "Hike the trails around Sovereign Hill",
    blurb:
      "A short ten-minute drive lands you at Sovereign Hill, ringed by bushland walking and mountain-bike tracks. Easy 3km loops for families, longer 8km circuits for keen hikers and mountain-bikers.",
    distance: "10 minutes' drive",
    tag: "Hiking",
    alt: "Illustrative photo of bushland hiking near Ballarat",
    image:
      "https://customer-assets.emergentagent.com/job_shady-booking-portal/artifacts/4epiipdf_image.png",
  },
  {
    title: "Lake Wendouree foreshore",
    blurb:
      "A flat 6km lakeside loop — perfect for a morning run, a slow family bike ride, or sunset paddle-board.",
    distance: "15 minutes' drive",
    tag: "Walks",
    alt: "Illustrative photo of Lake Wendouree foreshore, Ballarat",
    image:
      "https://customer-assets.emergentagent.com/job_shady-booking-portal/artifacts/gkv303i5_image.png",
  },
  {
    title: "Ballarat Wildlife Park",
    blurb:
      "Hand-feed kangaroos, meet wombats and koalas, and catch the daily crocodile show — a guaranteed kid-pleaser, just five minutes from your cabin.",
    distance: "5 minutes' drive",
    tag: "Family",
    alt: "Illustrative photo of an Australian wildlife park",
    image:
      "https://customer-assets.emergentagent.com/job_shady-booking-portal/artifacts/3kmi7oyw_image.png",
  },
];

export const AMENITIES = [
  { icon: "Tree", title: "Native gum forest", body: "12 acres of mature gum-tree shade and walking loops.", size: "lg" },
  { icon: "Bathtub", title: "Hot showers & amenities", body: "Clean and tidy bathrooms, family rooms and laundry." },
  { icon: "SwimmingPool", title: "Seasonal pool", body: "A small relaxation pool, open December to April." },
  { icon: "Fire", title: "Gas BBQs", body: "Communal gas BBQs set under the gums — perfect for an easy camp dinner." },
  { icon: "WifiHigh", title: "Free fast Wi-Fi", body: "Starlink-backed Wi-Fi available in select Ensuite Cabins." },
  { icon: "Dog", title: "Pet friendly", body: "Well-behaved dogs welcome on lead — quiet, family-friendly park with a welcome pack for four-legged guests." },
  { icon: "Bicycle", title: "Bike & walking tracks", body: "Quiet country roads and bushland tracks moments from the park." },
  { icon: "Coffee", title: "Camp kitchen", body: "A fully-equipped camp kitchen with weekend espresso cart — coming soon." },
];

export const GALLERY = [
  { src: "https://customer-assets.emergentagent.com/job_shady-booking-portal/artifacts/p3zvi2ul_8.png", alt: "Shady Acres Accommodation Park entrance and welcome sign, Ballarat" },
  { src: "https://customer-assets.emergentagent.com/job_shady-booking-portal/artifacts/o4e62xoc_5.png", alt: "Row of timber tourist cabins set among gum trees at Shady Acres" },
  { src: "https://customer-assets.emergentagent.com/job_shady-booking-portal/artifacts/ipueo8re_Caravan.V1.png", alt: "Powered caravan sites under gum trees at Shady Acres" },
  { src: "https://customer-assets.emergentagent.com/job_shady-booking-portal/artifacts/nyb4du99_7.png", alt: "Outdoor swimming pool with surrounding deck at Shady Acres" },
  { src: "https://customer-assets.emergentagent.com/job_shady-booking-portal/artifacts/d0uy64c8_4.png", alt: "Heritage orange cabin with green trim and front porch" },
  { src: "https://customer-assets.emergentagent.com/job_shady-booking-portal/artifacts/vyvjj9wh_3.png", alt: "Iconic A-frame amenities block — gents, ladies and laundry" },
  { src: "https://customer-assets.emergentagent.com/job_shady-booking-portal/artifacts/1eepqcyb_9.png", alt: "Heritage red phone box beside a white cabin under towering gum trees" },
  { src: "https://customer-assets.emergentagent.com/job_shady-booking-portal/artifacts/gqk85g7x_All_9.png", alt: "Shady grassed sites under tall eucalypts at Shady Acres Ballarat" },
];

export const TESTIMONIALS = [
  { name: "Hannah & Tom", from: "Geelong", quote: "The cabins are stunning — felt more like a boutique stay than a caravan park. We'll be back in autumn." },
  { name: "Mark D.", from: "Adelaide", quote: "Drive-through powered site was huge, water and grey on the slab. Best stop on our Vic loop." },
  { name: "The Patel Family", from: "Melbourne", quote: "Kids didn't want to leave. Pool, fire-pit, friendly staff — and the gum trees feel magical at dusk." },
  { name: "Liz", from: "Ballarat (local)", quote: "We send every interstate visitor here. It just keeps getting better, year on year." },
  { name: "Aaron", from: "Sydney (FIFO)", quote: "Stayed three weeks for work — quiet, clean and the team are great. Honestly nicer than a hotel." },
];

export const FAQS = [
  {
    q: "What makes Shady Acres the best caravan park in Ballarat?",
    a: "Shady Acres is a small, independently-owned caravan park in Ballarat, Victoria — twelve acres of native gum forest with well-maintained cabins, wide powered caravan sites and softgrass camping. Guests choose us for the quiet bushland setting, clean amenities, and friendly family-run service that big chain parks can't match.",
  },
  {
    q: "Where is your caravan park located in Ballarat?",
    a: "Our caravan park is in Warrenheip on the eastern edge of Ballarat — directly on the M8 (Western / National Highway) and 110km (about 90 minutes) west of Melbourne. We're 10 minutes from Sovereign Hill, 5 minutes from Ballarat Wildlife Park, and 15 minutes from Lake Wendouree.",
  },
  {
    q: "What types of accommodation in Ballarat do you offer?",
    a: "We offer five styles of accommodation in Ballarat: the Ensuite Cabin (self-contained, sleeps up to 6, ensuite bathroom, kitchenette, A/C, private deck), a cosy Standard Cabin for two, Powered Sites with 15A power, Ensuite Powered Sites with private bathroom, and Tent & Camping on soft grass. Every stay includes hot showers and access to our seasonal pool (open Dec–April).",
  },
  {
    q: "Is your park family-friendly?",
    a: "Yes — we are one of the most family-friendly caravan parks in Victoria. Families love our seasonal pool (open Dec–April), the kid-safe internal loop road, fire-pit circle for marshmallow nights, and Ballarat Wildlife Park just twenty minutes away.",
  },
  {
    q: "Is camping in Ballarat allowed at Shady Acres?",
    a: "Absolutely. Our camping sites are unpowered, soft-grass pitches set under mature gums with shared fire pits, hot showers nearby and a fully-equipped camp kitchen (coming soon). Camping in Ballarat is one of the cheapest ways to experience regional Victoria — from $35 per night for two adults.",
  },
  {
    q: "Are there hiking trails near the caravan park?",
    a: "Yes — Sovereign Hill is a 10-minute drive from the park, with bushland walking and mountain-bike tracks ringing the site. Easy 3km family loops and longer 8km circuits are signposted from the trailhead, and the quiet country roads near Shady Acres are great for cycling, too.",
  },
  {
    q: "Are pets welcome at your Ballarat caravan park?",
    a: "Yes — well-behaved dogs are welcome on caravan and camping sites year-round, and in selected pet-friendly cabins. Dogs must remain on lead at all times around the park (we don't have a dedicated off-lead area), and we ask owners to clean up after them. It's a calm, family-friendly park, so quiet, well-mannered dogs fit right in. Please mention your pet at booking so we can place you on a suitable site.",
  },
  {
    q: "What are the check-in and check-out times?",
    a: "Check-in is from 2pm and check-out is by 10am. Late check-in is no problem with prior notice — call ahead and we'll leave a key in the after-hours box.",
  },
  {
    q: "Do you offer long-stay or FIFO worker rates?",
    a: "Yes. We have discounted weekly and monthly rates for project workers, contractors and slow travellers, with quiet zones, secure parking and dedicated long-stay sites. Contact our team for a custom long-stay quote.",
  },
  {
    q: "Can I cancel or change my booking?",
    a: "Yes — free cancellation up to 14 days before arrival. Inside 14 days, your deposit is forfeited but is fully transferable to any future stay within 12 months.",
  },
];

// SEO meta per route — used by useDocumentMeta hook.
export const SEO_META = {
  "/": {
    title: "Caravan Park Ballarat — Cabins, Camping & Powered Sites · Shady Acres",
    description:
      "Shady Acres is a boutique caravan park in Ballarat, Victoria. Well-maintained cabins, powered caravan sites, and family-friendly camping under twelve acres of native gums — 90 minutes from Melbourne. Book direct.",
  },
  "/accommodation": {
    title: "Accommodation Ballarat — Cabins, Caravan Sites & Camping · Shady Acres",
    description:
      "Compare the ensuite cabin in Ballarat, our standard cabin, powered and ensuite-powered sites, and camping at Shady Acres Caravan Park. Ensuite cabin from $130, standard cabin from $90, powered sites from $40, camping from $35 per night. Book your Ballarat accommodation direct.",
  },
  "/amenities": {
    title: "Park Features & Amenities — Family-Friendly Caravan Park Victoria · Shady Acres",
    description:
      "Seasonal pool (Dec–April), fire-pit circle, hot showers and a camp kitchen (coming soon) — discover the amenities that make Shady Acres one of the most family-friendly caravan parks in Victoria.",
  },
  "/gallery": {
    title: "Gallery — Caravan Park Ballarat in Pictures · Shady Acres",
    description:
      "See our cabins, powered caravan sites, camping pitches and native bushland setting in Ballarat, Victoria. Real photos from our family-run caravan park.",
  },
  "/about": {
    title: "About Shady Acres — Family-Run Caravan Park in Ballarat, Victoria",
    description:
      "Independent, family-run caravan park in Ballarat — 12 acres of native gum forest, 90 minutes west of Melbourne. Read our story, location and what makes us different.",
  },
  "/contact": {
    title: "Contact Shady Acres — Group Bookings & Special Requests · Ballarat",
    description:
      "Ready to book? Use our booking engine for live availability. For group bookings, accessibility needs, long-stay enquiries or special requests, call, email, or send a note — we reply within the hour, seven days a week.",
  },
  "/book": {
    title: "Book Direct — Caravan Park, Cabins & Camping in Ballarat · Shady Acres",
    description:
      "Book your stay at Shady Acres Caravan Park in Ballarat direct via our secure booking engine. Live availability, real-time rates, no middleman fees — best rate guaranteed.",
  },
  "/policies": {
    title: "Policies, Terms & Privacy — Shady Acres Caravan Park Ballarat",
    description:
      "Cancellation policy, pet policy, terms & conditions and privacy policy for Shady Acres Caravan Park, Ballarat. Honest, plain-English house rules so there are no surprises at check-in.",
  },
  "/sitemap": {
    title: "Sitemap — Shady Acres Caravan Park Ballarat",
    description:
      "Index of every page on Shady Acres Caravan Park's website — accommodation, amenities, gallery, policies and booking pages.",
  },
};

